<template>
  <div class="delivery-info-container">
    <el-card>
      <template #header>
        <TitleItem title="配送信息" />
      </template>
      <el-form ref="deliveryInfoForm" :model="deliveryInfoModel" :rules="deliveryInfoRules" label-width="125px">
        <el-form-item style="margin-bottom: 22px" label="配送模板" prop="deliveryTemplateId">
          <el-select v-model="deliveryInfoModel.deliveryTemplateId">
            <el-option v-for="deliveryModel in deliveryTemplateList" :key="deliveryModel.id" :label="deliveryModel.name" :value="deliveryModel.id"></el-option>
          </el-select>
          <el-button type="text" style="margin-left: 15px" @click="manageDeliveryTempClick">管理模板</el-button>
          <el-button type="text" style="color: grey" @click="refreshDeliveryTempClick">刷新</el-button>
          <p class="tempTips" v-if="!deliveryInfoModel.deliveryTemplateId">请先选择配送模板</p>
        </el-form-item>

        <el-form-item label="运费模板" prop="shopFreightTemplateId">
          <el-select v-model="deliveryInfoModel.shopFreightTemplateId">
            <el-option v-for="freightModel in freightFormworkList" :key="freightModel.id" :label="freightModel.name" :value="freightModel.id"></el-option>
          </el-select>
          <el-button type="text" style="margin-left: 15px" @click="manageDeliveryMoneyTempClick">管理模板</el-button>
          <el-button type="text" style="color: grey" @click="refreshDeliveryMoneyTempClick">刷新</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { getGoodsDeliveryTemplate, getGoodsFreightFormwork } from "@/api/publishGoods/publishGoods";
import { createNamespacedHelpers } from "vuex";
import TitleItem from "./TitleItem.vue";

const { mapState } = createNamespacedHelpers("publishGoods/publishGoods");
export default {
  components: {
    TitleItem,
  },
  data() {
    return {
      deliveryTemplateList: [],
      freightFormworkList: [],
      is_delivery_area_goods: 1, //  = 1 时，展示 仅配送区域内展示商品 这一行配置；
      deliveryInfoModel: {
        deliveryTemplateId: "", //店铺配送模板id
        isDeliveryAreaGoods: "0", //仅配送区域内展示商品 0:否，1:是
        shopFreightTemplateId: "", // 运费模版ID
      },
      deliveryInfoRules: {
        deliveryTemplateId: [{ required: true, message: "请选择配送模板", trigger: "blur" }],
        shopFreightTemplateId: [{ required: true, message: "请选择运费模板", trigger: "blur" }],
      },
    };
  },
  created() {
    this.loadGoodsDeliveryTemplate();
    this.loadGoodsFreightFormwork();
  },
  computed: {
    ...mapState(["goodsDetail", "shopConfig"]),
  },
  watch: {
    goodsDetail(newVal) {
      this.deliveryInfoModel.deliveryTemplateId = newVal.firstSku.deliveryTemplateId;
      this.deliveryInfoModel.isDeliveryAreaGoods = newVal.firstSku.isDeliveryAreaGoods;
      this.deliveryInfoModel.shopFreightTemplateId = newVal.firstSku.shopFreightTemplateId;
    },
    shopConfig(newVal) {
      this.is_delivery_area_goods = newVal.funcSettingMap.is_delivery_area_goods;
    },
  },
  methods: {
    async loadGoodsDeliveryTemplate() {
      const loading = this.$loading({
        lock: false,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      try {
        const result = await getGoodsDeliveryTemplate();

        this.deliveryTemplateList = result.data;
        if (result.data.length > 0) {
          this.deliveryInfoModel.deliveryTemplateId = result.data[0].id;
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
      } finally {
        loading.close();
      }
    },
    async loadGoodsFreightFormwork() {
      const loading = this.$loading({
        lock: false,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        const result = await getGoodsFreightFormwork();

        this.freightFormworkList = result.data;
        if (result.data.length > 0) {
          this.deliveryInfoModel.shopFreightTemplateId = result.data[0].id;
        }
        // eslint-disable-next-line no-empty
      } catch (error) {
      } finally {
        loading.close();
      }
    },
    //跳转 home里面的配送模版管理页
    manageDeliveryTempClick() {
      if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: `${process.env.VUE_APP_APP}mj/toOtherAddr.do?appid=1&isShowTitle=1`,
              title: "配送模板",
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(`${process.env.VUE_APP_APP}mj/toOtherAddr.do?appid=1&isShowTitle=1`);
      }
    },
    //刷新配送模版数据
    refreshDeliveryTempClick() {
      this.loadGoodsDeliveryTemplate();
    },
    //跳转 home里面的运费模版管理页
    manageDeliveryMoneyTempClick() {
      if (self != top) {
        window.parent.postMessage(
          {
            fn: "open",
            data: {
              url: `${process.env.VUE_APP_APP}mj/freight/toFreightListEtp.do?appid=1&isShowTitle=1`,
              title: "运费模板",
              target: 0,
            },
          },
          "*"
        );
      } else {
        window.open(`${process.env.VUE_APP_APP}mj/freight/toFreightListEtp.do?appid=1&isShowTitle=1`);
      }
    },
    //刷新运费模版数据
    refreshDeliveryMoneyTempClick() {
      this.loadGoodsFreightFormwork();
    },
    async subMitCheck() {
      try {
        await this.$refs.deliveryInfoForm.validate();

        return this.deliveryInfoModel;
      } catch (error) {
        return;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-info-container {
  padding-top: 20px;
  .tempTips {
    font-size: 12px;
    color: #ff0023;
  }
}
</style>
